import React from 'react';

interface ImageRawProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
}

/**
 * ImageRaw component - Uses raw HTML img tag
 * Automatically handles URL replacement for local development
 */
export const ImageRaw: React.FC<ImageRawProps> = ({ src, alt, ...props }) => {
  // Replace static.kidsplaza.vn with localhost:6006 in local environment
  const getLocalSrc = (originalSrc: string): string => {
    // Check if running in development/local environment
    const isLocal = process.env.NODE_ENV === 'development' ||
                   (typeof window !== 'undefined' && window.location.hostname === 'localhost');

    if (isLocal && originalSrc.includes('static.kidsplaza.vn')) {
      return originalSrc.replace('https://static.kidsplaza.vn/', 'https://static.kidsplaza.vn/');
    }

    return originalSrc;
  };

  return (
    <img
      {...props}
      src={getLocalSrc(src)}
      alt={alt}
    />
  );
};

export default ImageRaw;
